module.exports = __webpack_public_path__ + "static/card-energy-initiatives-2-d81221bba1cf714f6ca3390528a6b870.jpg";